import styled from 'styled-components';

interface CollapsibleHeaderWrapProps {
    background?: string;
    padding?: string;
    borderBottom?: string;
  }

export const CollapsibleHeaderWrap = styled.div<CollapsibleHeaderWrapProps>`
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    padding: ${(props) => props.padding || 'initial'};
    background: ${(props) => props.background || 'initial'};
    border-bottom: ${(props) => props.borderBottom || 'initial'};
`;
